<ng-template #cpuInput>
  <mat-form-field>
    <mat-label>{{formData.label}}</mat-label>
    <input matInput
      type="text"
      [formControl]="formGroup.controls[formName]"
      [matAutocomplete]="auto"
      [required]="formData.isRequired">
      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
        @for (option of filteredOptions | async; track option) {
          <mat-option [value]="option">
            {{option.label}}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </ng-template>

  <app-base [componentsTemplate]="cpuInput" [childContext]="ctx"></app-base>
